import { jsxs, jsx } from "react/jsx-runtime";
const IconShieldCheckSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 46 57",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M44.936 4.7a2.885 2.885 0 0 0-2.415-.57 23.19 23.19 0 0 1-9.319.023A23.102 23.102 0 0 1 24.64.508a2.892 2.892 0 0 0-3.278 0 23.102 23.102 0 0 1-8.563 3.645 23.19 23.19 0 0 1-9.32-.024 2.899 2.899 0 0 0-2.414.57A2.83 2.83 0 0 0 0 6.923v21.24a25.484 25.484 0 0 0 2.865 11.75 25.721 25.721 0 0 0 7.974 9.146l10.493 7.413a2.891 2.891 0 0 0 3.335 0l10.494-7.413a25.721 25.721 0 0 0 7.974-9.146A25.484 25.484 0 0 0 46 28.163V6.922a2.833 2.833 0 0 0-1.064-2.224ZM40.25 28.161a19.821 19.821 0 0 1-2.226 9.137 20.004 20.004 0 0 1-6.198 7.113L23 50.656l-8.826-6.244A20.005 20.005 0 0 1 7.976 37.3a19.821 19.821 0 0 1-2.226-9.137v-17.96A28.946 28.946 0 0 0 23 6.238 28.946 28.946 0 0 0 40.25 10.2v17.961Zm-12.823-6.528-7.733 7.697-2.559-2.566a2.9 2.9 0 0 0-2.041-.838 2.9 2.9 0 0 0-2.041.838 2.85 2.85 0 0 0-.846 2.024c0 .76.304 1.488.845 2.024l4.6 4.562a2.877 2.877 0 0 0 2.042.843 2.895 2.895 0 0 0 2.041-.843l9.89-9.722a2.85 2.85 0 0 0 .846-2.024 2.85 2.85 0 0 0-.846-2.024 2.899 2.899 0 0 0-2.041-.838c-.766 0-1.5.301-2.041.838l-.116.029Z" })
    ]
  }
);
export {
  IconShieldCheckSvg
};
